import { toast } from "react-toastify";

// Marking an appointment as refunded only records it in VerySoul; no money moves.
// Remind the user to complete the refund through the medium's payment integration.
export const REFUND_PAYMENT_NOTICE =
  "This only marks the appointment as refunded in VerySoul. Please complete the refund through your payment integration (Stripe, PayPal or Square) so your client receives their money back.";

// `response` is the axios response from the `refunding-appointment` call. Prefers the
// backend's notice (data.refund_notice) so the wording lives in one place.
export const showRefundNotice = (response) => {
  const data = response && response.data && response.data.data;
  const notice = (data && data.refund_notice) || REFUND_PAYMENT_NOTICE;
  toast.info(`Appointment marked as refunded. ${notice}`, {
    position: "top-center",
    autoClose: 12000,
  });
};
